import search from "src/components/search/search";
import { articlesExtend, getDynamicContent, findsite } from "src/scripts/mixin";

export default () => {
    
    const contentcontainer = document.getElementById("site_content");

    const siteinfo = findsite();
    
    document.title = siteinfo.previewItem + " - Kongsberg historiefortelling";
    
    let html = ``;
    
    // r += heroSearch();

    // r = hero(data);
    contentcontainer.innerHTML =  `
    <div class="search" id="searchframework">
        
    </div>
        
    `;
    
    search()


}

